import * as constants from './constants';
import http from '../../../utils/request';

const getInitData = (result) => ({
  type: constants.GET_INIT_DATA,
  initData: result.initData,
  domain: result.domain,      // 领域
  patent: result.patent,      // 专利情况
  operation: result.operation,// 合作需求
  maturity: result.maturity,  // 成果成熟度
});

const submitState = (result, type) => ({
  type: constants.SUBMIT_STATE,
  submitState: type,
  msg: result.msg
});

export const fetchPublishData = () => {
  return (dispatch) => {
    http('post', '/achieve/detail/message').then((res) => {
      // console.log('initdata',res.data);
      dispatch(getInitData(res.data));
      // dispatch(submitState('success'))
    })
  }
}

export const submitFormData = (obj) => {
  return (dispatch) => {
    http('post', '/achieve/detail/publish', obj).then((res) => {
      console.log('res',res)
      if (res.code === 200) {
        // console.log('success');
        dispatch(submitState(res, 'success'));
      } else {
        dispatch(submitState(res, 'error'));
      }
    });
  }
}